<template>
  <div>
    <a-select
      :class="class"
      class="w100"
      :value="value"
      allow-clear
      show-search
      :multiple="false"
      :placeholder="placeholder"
      option-filter-prop="title"
      @change="onChange"
      @clear="onClear"
    >
      <a-select-option
        v-for="item in data?.records"
        :key="item.id"
        :value="item.name"
        :title="item.name"
        >{{ item.name }}</a-select-option
      >
    </a-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { UnitService } from "@/views/material/unit/unit.service";

/**
 * 结算单位选择器
 *
 * 使用方式:
 * <unit-select-name v-model:value="formRef.unitId"></unit-select-name>
 */
export default defineComponent({
  isGlobal: true,
  name: "UnitSelectName",
  props: {
    class:{
    type: String, default: 'append-to-body'
    },
    value: { type: String, default: undefined },

    placeholder: { type: String, default: "请选择" },
  },
  emits: ["update:value", "change"],
  setup(props, { attrs, slots, emit }) {
    const { data, run, loading } = UnitService.useSimpleListApi();

    const onChange = (name) => {
      emit("update:value", name);
      emit("change", name);
    };

    const onClear = () => {
      emit("update:value", undefined);
      emit("change", undefined);
    };

    onMounted(async () => {
      await run();
    });
    return {
      data,
      loading,
      onChange,
      onClear,
    };
  },
});
</script>
